<template>
  <a-card title="推荐课程" :bordered="false" style="height: 780px">
    <template #extra
      ><router-link to="/courseList"
        >查看更多<img src="../../assets/images/index_rightArrow1.png" class="rightArrow1" alt="" /></router-link
    ></template>
    <div class="push_hot">
      <router-link :to="`/courseDetails?id=${hot.id}`" target="_blank" v-for="hot in hotCourseData" :key="hot.id">
        <div class="hot_item">
          <div class="cover">
            <img :src="hot.thumb" alt="" />
          </div>
          <h3>
            {{ hot.title }}
          </h3>
          <div class="info">
            <span>
              <span class="price_selling">￥{{ hot.price_selling }}</span>
              <span class="price_market" v-if="hot.price_market != ''">￥{{ hot.price_market }}</span>
              <a-rate v-model:value="hot.star" allow-half disabled />
            </span>
            <a-button type="link">立即前往<i class="iconfont icon-zwjinru"></i></a-button>
          </div>
        </div>
      </router-link>
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'HotCourse',
  data() {
    return {
      hotCourseData: [],
    }
  },
  mounted() {
    this.getHotCourseData()
  },
  methods: {
    async getHotCourseData() {
      const { data: res } = await this.$http.post('course/recommend_course')
      this.hotCourseData = res.data
    },
  },
}
</script>

<style lang="less" scoped>
.hot_item {
  margin-bottom: 40px;
  .cover {
    width: 347px;
    height: 231px;
    margin-bottom: 20px;
    border-radius: 4px;
    background-color: #fff;
    img {
      width: 100%;
    }
  }
  h3 {
    .hot_icon {
      width: 20px;
      height: 20px;
    }
    font-size: 16px;
    color: rgba(0, 0, 0, 0.65);
    margin-bottom: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    > span {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
      .price_selling {
        color: #ff4d4f;
      }
      .price_market {
        text-decoration: line-through;
      }
    }
    .ant-rate {
      font-size: 16px;
      margin-left: 16px;
    }
    .ant-btn {
      font-size: 16px;
      padding: 0;
    }
  }
}
</style>
